import { css } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

const mediaQueries = {
  xs: `(max-width: ${cssBreakpoints.xsUp})`,
  sm: `(min-width: ${cssBreakpoints.xsUp}) and (max-width: ${cssBreakpoints.mdDown})`,
  md: `(min-width: ${cssBreakpoints.mdUp}) and (max-width: ${cssBreakpoints.mdDown})`,
  lg: `(min-width: ${cssBreakpoints.mdUp}) and (max-width: ${cssBreakpoints.lgDown})`,
  xl: `(min-width: ${cssBreakpoints.lgUp})`,
};

const mediaEntries: Partial<
  Record<
    keyof typeof mediaQueries,
    (...args: Parameters<typeof css>) => ReturnType<typeof css>
  >
> = {};

(Object.keys(mediaQueries) as Array<keyof typeof mediaQueries>).forEach(
  (label) => {
    mediaEntries[label] = (...args: Parameters<typeof css>) => css`
      @media ${mediaQueries[label]} {
        ${css(...args)};
      }
    `;
  },
);

export const media = mediaEntries as Record<
  keyof typeof mediaQueries,
  (...args: Parameters<typeof css>) => ReturnType<typeof css>
>;

function generateMediaQuery({
  xs,
  sm,
  md,
  lg,
  xl,
}: {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
}) {
  return [
    xs && `(max-width: ${cssBreakpoints.xsUp})`,
    sm &&
      `(min-width: ${cssBreakpoints.xsUp}) and (max-width: ${cssBreakpoints.smDown})`,
    md &&
      `(min-width: ${cssBreakpoints.smUp}) and (max-width: ${cssBreakpoints.mdDown})`,
    lg &&
      `(min-width: ${cssBreakpoints.mdUp}) and (max-width: ${cssBreakpoints.lgDown})`,
    xl && `(min-width: ${cssBreakpoints.lgUp})`,
  ]
    .filter(Boolean)
    .join();
}

export function matchSize(sizes: {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
}) {
  return typeof window === 'object'
    ? window.matchMedia(generateMediaQuery(sizes)).matches
    : false;
}
